import { PolarPointSeries } from '@arction/lcjs';
import React, { useEffect, useRef, useState } from 'react';
import { isPropertyAccessOrQualifiedName } from 'typescript';
import GameManager from '../../../cvp-webgames-core/GameManager';
import Tools from '../../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../../misc/globals';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';
import ApneaBar from './ApneaBar';
import ApneaClockUI from './ApneaClockUI';
import ETC02GraphUI, { ETC02GraphUIData } from './ETC02Graph';
import MonitorUI, { MonitorUIData } from './MonitorUI';
import Pa02GraphUI from './Pa02GraphUI';
import Sa02GraphUI from './Sa02GraphUI';
import SmeDebugUI from './SmeDebugUI';
import VitalsUI from './VitalsUI';

var etc02Rendered = <ETC02GraphUI isETC02Attached={true}
						data={[]}
						isDead={false}
						key={Tools.generateGuid()}
						canvasHeight={30}
						onDataUpdated={(updatedData: ETC02GraphUIData) => {
							// etc02Data = updatedData.data;
						}}></ETC02GraphUI>
var isDead = false;
var isMounted = false;

const SideMenuUI = (props: UIProperties<SideMenuUIConfig>) => {
	useEffect(() => {
		(props.parameters as any).onForceUpdate = () => {
			const win = window as any;
			if(!props.parameters.updatedStuff) {
				props.parameters.updatedStuff = {};
			}
			if(win.monitorRefresh)
				win.monitorRefresh(props.parameters.updatedStuff);

			if(win.apneaTimerRefresh)
				win.apneaTimerRefresh(props.parameters.updatedStuff);

			if(win.apneaBarRefresh) {
				win.apneaBarRefresh(props.parameters.updatedStuff);
			}

			if(win.sa02GraphRefresh) {
				win.sa02GraphRefresh(props.parameters.updatedStuff);
			}

			if(props.parameters.updatedStuff.onInductionTimerRanOut2) {
				props.parameters.onInductionTimerRanOut2 = props.parameters.updatedStuff.onInductionTimerRanOut2;
			}

			props.parameters.updatedStuff = undefined;
		}
	})
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			left: '0',
			top: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none',
			visibility: 'hidden'
		}} id='side-menu-root-obj'>
			<ApneaClockUI parameters={{
				apneaTimeInSeconds: props.parameters.apneaTimeInSeconds,
				inductionTimeInSeconds: props.parameters.inductionTimeInSeconds,
				isIdle: props.parameters.isApneaTimerIdle,
				onInductionTimerRanOut: () => {
					props.parameters.onInductionTimerRanOut();
					if(props.parameters.onInductionTimerRanOut2) {
						props.parameters.onInductionTimerRanOut2();
					}
				},
				onApneaTimerRanOut: () => {
					props.parameters.onApneaTimerRanOut();
				}
			}} id={Tools.generateGuid()} dispatch={props.dispatch} key={Tools.generateGuid()}></ApneaClockUI>
			<div style={{
				border: '3px solid rgb(192, 161, 6)',
				backgroundColor: 'rgb(36, 36, 36)',
				position: 'absolute',
				right: '110px',
				top: '396px',
				width: '250px',
				height: '330px'
			}}>
				<div style={{
					position: 'absolute',
					top: '10px',
					left: '50%',
					width: '210px',
					height: '300px',
					transform: 'translate(-50%, 0)'
				}} className='modal-bg'>
					<img style={{
						position: 'absolute',
						width: '100%'
					}} src="./assets/images/side-menu/Template.png" alt="" />
					{/* <img style={{
						position: 'absolute',
						top: '159px',
						left: '17px',
						width: '176px'
					}} src="./assets/images/side-menu/Sa02.png" alt="" /> */}
				</div>
				
				<Pa02GraphUI parameters={{
				}} id={Tools.generateGuid()} dispatch={props.dispatch} key={Tools.generateGuid()}></Pa02GraphUI>

				<Sa02GraphUI parameters={{
					apneaTimeInSeconds: props.parameters.apneaTimeInSeconds,
					inductionTimeInSeconds: props.parameters.inductionTimeInSeconds,
					isIdle: props.parameters.isApneaTimerIdle,
				}} id={Tools.generateGuid()} dispatch={props.dispatch} key={Tools.generateGuid()}></Sa02GraphUI>

				<ApneaBar parameters={{
					startOffsetInSeconds: props.parameters.inductionTimeInSeconds,
					timeInSeconds: props.parameters.apneaTimeInSeconds,
					isIdle: props.parameters.isApneaTimerIdle
				}} id={Tools.generateGuid()} dispatch={props.dispatch} key={Tools.generateGuid()}></ApneaBar>
			</div>

			<VitalsUI parameters={{
			}} id={Tools.generateGuid()} dispatch={props.dispatch} key={Tools.generateGuid()}></VitalsUI>

			<MonitorUI parameters={{
				gameManager: props.parameters.gameManager,
				apneaTimeInSeconds: props.parameters.apneaTimeInSeconds,
				inductionTimeInSeconds: props.parameters.inductionTimeInSeconds,
				isIdle: props.parameters.isApneaTimerIdle,
				sa02: props.parameters.sa02,
				stopSa02: props.parameters.stopSa02,
				bloodPressureNumerator: props.parameters.bloodPressureNumerator,
				bloodPressureDenominator: props.parameters.bloodPressureDenominator,
				bloodPressureMinNumerator: props.parameters.bloodPressureMinNumerator,
				bloodPressureMinDenominator: props.parameters.bloodPressureMinDenominator,
				bloodPressureMaxNumerator: props.parameters.bloodPressureMaxNumerator,
				bloodPressureMaxDenominator: props.parameters.bloodPressureMaxDenominator,
				respirationRate: props.parameters.respirationRate,
				etc02: props.parameters.etc02,
				heartRate: props.parameters.heartRate,
				heartRateMax: props.parameters.heartRateMax,
				showETC02: props.parameters.showETC02,
				onDataUpdated: (newData: MonitorUIData) => {
					// console.log(newData);
					isDead = newData.heartRate === 0;
					(window as any)['vitals'] = newData;
				},
				onRenderETC02: () => {
					return (etc02Rendered);
				}
			}} id={Tools.generateGuid()} dispatch={props.dispatch} key={Tools.generateGuid()}></MonitorUI>

			<Custom508Control2></Custom508Control2>

			{globals.showDebugForComponents ? <SmeDebugUI></SmeDebugUI> : (null)}
		</div>
	);

};

const Custom508Control2 = () => {
	const [forceUpdate, setForceUpdate] = useState(false);

	(window as any).onForceCCButtonRerender = () => {
		setForceUpdate(!forceUpdate);
	}

	return (
		(window as any).isDisplayingHud ? (window as any).onRenderCCToggle() : null
	);

};

export interface SideMenuUIConfig extends BaseConfig{
	showETC02?: boolean;
	notBreathing?: boolean;
	apneaTimeInSeconds?: number;
	gameManager?: GameManager;
	heartRate?: number;
	heartRateMax?: number;
	respirationRate?: number;
	etc02?: number;
	sa02?: number;
	bloodPressureNumerator?: number;
	bloodPressureDenominator?: number;
	bloodPressureMinNumerator?: number;
	bloodPressureMinDenominator?: number;
	bloodPressureMaxNumerator?: number;
	bloodPressureMaxDenominator?: number;
	inductionTimeInSeconds?: number;
	isApneaTimerIdle?: boolean;
	resetEtc02?: boolean;
	stopSa02?: boolean;
	onApneaTimerRanOut?: () => void;
	onInductionTimerRanOut?: () => void;
	onInductionTimerRanOut2?: () => void;
	updatedStuff?: SideMenuUIConfig;
}

export default SideMenuUI;